import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AdvancedDataContext = createContext();

export const AdvancedDataProvider = ({ children }) => {
  const fetchData = async (url, token) => {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`, // Replace 'YOUR_ACCESS_TOKEN' with your actual access token
        },
      });
      return response.data;
    } catch (error) {
      if (error.response.status === 404) {
        return [];
      }
      console.error(`Error fetching data from ${url}:`, error);
      return null;
    }
  };

  const fetchMultipleApis = async (urls) => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;
    const promises = urls.map((url) => fetchData(url, token));
    return Promise.all(promises);
  };

  const [apiData, setApiData] = useState(null);
  useEffect(() => {
    // console.log("state apiData", apiData);
  }, [apiData]);

  const dataFetch = async (searchQuery) => {
    // console.log('query from data provider',searchQuery)

    const fetchDataAndStore = async () => {
      // console.log("enterd data fetch")
      const apiUrls = [
        // `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/search?year=${searchQuery.year}&startingmonth=${searchQuery.startMonth+1}&endingmonth=${searchQuery.endMonth+1}`,
        // `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/search?year=${searchQuery.year}&startingmonth=${searchQuery.startMonth+1}&endingmonth=${searchQuery.endMonth+1}&stokistname=${searchQuery.stokist}`,
        // `${process.env.REACT_APP_SERVER_BASE_URL}/stokists/completelist`,
        // `${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/rep/search?name=${searchQuery.rep}&startyear=${searchQuery.year}&endyear=${searchQuery.year}&actual=true&startingmonth=${searchQuery.startMonth+1}&endingmonth=${searchQuery.endMonth}`,
        `${
          process.env.REACT_APP_SERVER_BASE_URL
        }/transactionreports/rep/search?startyear=${searchQuery.year}&endyear=${
          searchQuery.year
        }&actual=true&startingmonth=${searchQuery.startMonth + 1}&endingmonth=${
          searchQuery.endMonth
        }`,
      ];

      try {
        const data = await fetchMultipleApis(apiUrls);
        const newData = {};
        apiUrls.forEach((url, index) => {
          newData[index] = data[index] ? data[index] : [];
        });
        setApiData(newData);
        // console.log('from advanced data provider',newData)
        // localStorage.setItem('monthData',JSON.stringify(newData))
        // console.log("data from context:",newData)
      } catch (error) {
        console.error("Error fetching data from APIs:", error);
      }
    };
    fetchDataAndStore();
  };
  return (
    <AdvancedDataContext.Provider value={{ apiData, dataFetch, setApiData }}>
      {children}
    </AdvancedDataContext.Provider>
  );
};

export const useAdvancedDataContext = () => {
  return useContext(AdvancedDataContext);
};
